import ContextMenu from "../contextMenu/contextMenu.vue";

export default {
    props: [
        "loadGrid",
        "autoBind",
        "additionalParameters",
        "columns",
        "model",
        "contextMenuItems",
        "gridContextOpen",
        "data",
        "dataSourceUrl",
        "hasDetail",
        "detailType", // text , grid
        "detailConfig",
        "detailTemplate",
        "filterable",
        "hasCheckbox",
        "hasContextMenu",
        "hasSearch",
        "hasPaging",
        "pagingType", // scroll, numeric
        "selectable",
        "reorderable",
        "schema",
        "sortable",
        "toolbar",
        "resizable",
        "reloadGrid",
        "boldOnField",
        "columnsMenu",
        "group",
        "hasServerSorting",
        "height",
        "getColumns",
        "editable",
        "onSave"
    ],
    data() {
        return {
            changeColumnsState: true,
            hiddenColumns: [],
            visibleColumns: [],
            customGridColumnWidth: [],
            customGridColumnOrder: [],
            gridEl: null,
            gridData: null,
            gridPrevFilters: null,
            gridToolbarEl: null,
            gridToolbarData: null,
            toolbarMapped: [],
            scrollBarWidth: kendo.support.scrollbar(),
            dataBindingFlag: false,
            selectedItems: [],
            pagingIncrement: 5,
            direction: payload.currentLocale.IsRightToLeft
        }
    },
    watch: {
        data() {
            this.init();
        },
        dataSourceUrl(newValue, oldValue) {
            payload.TaskGridRecord = 0;
            this.dataSourceUrl = newValue;
            if (this.gridData) {
                var that = this;
                if (that.getColumns != undefined)
                    this.getColumns(function () {
                        that.gridData.setOptions(that.buildConfig());
                        that.gridToolbarEl = that.gridEl.find('.rayBPMSGridToolbarTemplate');
                        that.buildToolbar();
                        that.bindEvents();
                    });
                else {
                    that.gridData.setOptions(that.buildConfig());
                    that.gridToolbarEl = that.gridEl.find('.rayBPMSGridToolbarTemplate');
                    that.buildToolbar();
                    that.bindEvents();
                }
            }
        },
        loadGrid() {

            this.init();
        },
        reloadGrid() { 
            payload.TaskGridRecord = 0;
            if (this.gridData) {
                var that = this;
                if (that.getColumns != undefined)
                    this.getColumns(function () {
                        that.gridData.setOptions(that.buildConfig());
                        that.gridToolbarEl = that.gridEl.find('.rayBPMSGridToolbarTemplate');
                        that.buildToolbar();
                        that.bindEvents();
                        var searchStr = sessionStorage.getItem('cartableSearchItem');
                        if (searchStr != undefined && searchStr != null) {
                            $(that.gridEl).find('.rayvarzBPMSGridSearch').val(searchStr);
                            if (searchStr != '') {
                                that.gridSearch(searchStr);
                            }
                        }
                        that.setColumnsVisibility();
                    });
                else {
                    that.gridData.setOptions(that.buildConfig());
                    that.gridToolbarEl = that.gridEl.find('.rayBPMSGridToolbarTemplate');
                    that.buildToolbar();
                    that.bindEvents();
                    var searchStr = sessionStorage.getItem('cartableSearchItem');
                    if (searchStr != undefined && searchStr != null) {
                        $(that.gridEl).find('.rayvarzBPMSGridSearch').val(searchStr);
                        if (searchStr != '') {
                            that.gridSearch(searchStr);
                        }
                    }
                    that.setColumnsVisibility();
                }
            }

        }
    },
    computed: {
        gridContextItems() {
            return typeof this.contextMenuItems == 'function' ? this.getContextMenuItems : this.contextMenuItems;
        },
        isMultipleSelectable() {
            return this.selectable.toString().indexOf('multiple') > -1;
        }
    },
    methods: {
        datasource_error(a) {
            utils.showAjaxError(a.xhr, a.status, true);
        },
        init() {

            payload.TaskGridRecord = 0;
            if (this.loadGrid == "false")
                return;
            if (!this.gridData) {
                this.gridEl = $(this.$el).find('.rayvarzBPMSGrid');
                if (this.data || this.dataSourceUrl) {
                    var that = this;
                    if (that.getColumns != undefined)
                        that.getColumns(function () {
                            that.gridData = that.gridEl.kendoGrid(that.buildConfig()).data('kendoGrid');
                            that.gridToolbarEl = that.gridEl.find('.rayBPMSGridToolbarTemplate');
                            that.buildToolbar();
                            that.bindEvents();
                            var searchStr = sessionStorage.getItem('cartableSearchItem');
                            if (searchStr != undefined && searchStr != null) {
                                $(that.gridEl).find('.rayvarzBPMSGridSearch').val(searchStr);
                                if (searchStr != '') {
                                    that.gridSearch(searchStr);
                                }
                            }
                            that.setColumnsVisibility();
                        });
                    else {
                        that.gridData = that.gridEl.kendoGrid(that.buildConfig()).data('kendoGrid');
                        that.gridToolbarEl = that.gridEl.find('.rayBPMSGridToolbarTemplate');
                        that.buildToolbar();
                        that.bindEvents();
                        var searchStr = sessionStorage.getItem('cartableSearchItem');
                        if (searchStr != undefined && searchStr != null) {
                            $(that.gridEl).find('.rayvarzBPMSGridSearch').val(searchStr);
                            if (searchStr != '') {
                                that.gridSearch(searchStr);
                            }
                        }
                        that.setColumnsVisibility();
                    }

                }
            }



        },
        destroy() {

            if (this.gridData) {
                this.gridData.destroy();
                this.gridEl.html('');
            }
        },
        buildConfig() {
            var self = this;
            return {
                allowCopy: true,
                autoBind: this.autoBind !== undefined ? this.autoBind : true,
                columns: this.buildColumns(),
                columnMenu: this.columnsMenu === "true" ? { columns: true } : false,
                columnHide: function (e) {
                    var isExist = false;
                    for (var i = 0; i < self.hiddenColumns.length; i++) {
                        if (e.column.name === self.hiddenColumns[i].name)
                            isExist = true;
                    }
                    if (!isExist)
                        self.hiddenColumns.push(e.column);
                    for (var i = 0; i < self.visibleColumns.length; i++) {

                        if (e.column.name === self.visibleColumns[i].name)
                            self.visibleColumns.splice(i, 1);
                    }

                    window.localStorage.setItem('hiddenColumns', JSON.stringify(self.hiddenColumns));
                    window.localStorage.setItem('visibleColumns', JSON.stringify(self.visibleColumns));

                },
                columnShow: function (e) {
                    var isExist = false;
                    for (var i = 0; i < self.visibleColumns.length; i++) {

                        if (e.column.name === self.visibleColumns[i].name)
                            isExist = true;
                    }
                    if (!isExist)
                        self.visibleColumns.push(e.column);
                    for (var i = 0; i < self.hiddenColumns.length; i++) {

                        if (e.column.name === self.hiddenColumns[i].name)
                            self.hiddenColumns.splice(i, 1);
                    }
                    window.localStorage.setItem('hiddenColumns', JSON.stringify(self.hiddenColumns));
                    window.localStorage.setItem('visibleColumns', JSON.stringify(self.visibleColumns));

                },
                columnReorder: function (option) {
                    var that = this;
                    setTimeout(function () {
                        that.customGridColumnOrder = that.columns;
                        window.localStorage.setItem('CartableGridColumnOrder', JSON.stringify(that.customGridColumnOrder));
                    })

                },
                columnResize: function (option) {
                    var that = this;
                    setTimeout(function () {
                        that.customGridColumnWidth = that.columns;
                        window.localStorage.setItem('CartableGridColumnWidth', JSON.stringify(that.customGridColumnWidth));
                    })

                },
                filter: function (e) { },
                change: this.gridSelectChange,
                dataSource: this.buildDataSource(),
                dataBound: this.dataBound,
                detailTemplate: this.hasDetail === "true" && this.detailTemplate ? kendo.template(this.detailTemplate) : null,
                detailInit: this.hasDetail === "true" ? (typeof this.detailConfig === 'function' ? this.detailConfig : this.gridDetailInit) : null,
                //mobile:true,
                pageable: this.buildPaging(),
                resizable: !!this.resizable,
                selectable: this.selectable !== undefined ? this.selectable : false,
                reorderable: this.reorderable !== undefined ? this.reorderable : false,
                toolbar: "<div class='rayBPMSGridToolbarTemplate'></div>",
                filterable: this.filterable == "true",
                sortable: this.sortable == "true",
                height: this.height,
                editable: this.editable == "true",
                save: function (e) {
                    if (self.onSave)
                        self.onSave(e);
                }
            }
        },
        buildColumns() { 
            if (this.hasCheckbox === "true" && this.columns && this.columns.filter((value) => { return value.field == 'checkbox'; }).length == 0) {
                this.columns.splice(1, 0,
                    {
                        field: 'checkbox',
                        title: "",
                        filterable: false,
                        sortable: false,
                        groupable: false,
                        selectable: false,
                        headerTemplate: this.isMultipleSelectable ? "<input class='rayBPMSGridCheckAll' type='checkbox'/>" : "",
                        menu: false,
                        width: 35,
                        template: function (dataItem) {
                            return `<input taskId='${dataItem.Id}' class='rayBPMSGridCheckbox'  type='checkbox'/>`;
                        }
                    }
                );

            }

            return this.columns;
        },
        buildDataSource() { 
            let dSource = this.dataSourceUrl ?
                new kendo.data.DataSource(
                    {
                        transport: {
                            type: "json",
                            read: {
                                url: this.dataSourceUrl,
                                type: "POST",
                                dataType: "json",
                                contentType: "application/json; charset=utf-8",
                                beforeSend: function (xhr) {
                                    xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
                                    xhr.setRequestHeader('rayheader', window.sessionStorage.getItem('accessToken'));
                                },
                                error: function (e) { 
                                }
                            },
                            parameterMap: (data, operation) => {
                                if (this.additionalParameters) {
                                    data.Data = this.additionalParameters;
                                }
                                return JSON.stringify(data);
                            }
                        },
                        schema: this.schema == null ? {
                            data: "Data",
                            total: function (response) { return response.Total; },
                            aggregates: "Aggregates",
                            model: this.model

                        } : this.schema,
                        page: 1,
                        pageSize: this.pagingType === "scroll" ? 30 : 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: this.hasServerSorting === undefined ? true : this.hasServerSorting == "true",
                        group: this.group,
                    }) :
                (Array.isArray(this.data) ?
                    {
                        data: this.data,
                        pageSize: 10
                    } : []);
            dSource.bind("error", this.datasource_error);
            return dSource;
        },
        buildPaging() {

            let result = false;
            if (this.hasPaging) {
                switch (this.pagingType) {
                    case "scroll":
                        result = {
                            pageSize: 10,
                            refresh: true,
                            numeric: true,
                            buttonCount: 0,
                            previousNext: false,
                            info: true
                        };
                        break;
                    case "numeric":
                    default:
                        result = {
                            pageSize: 10,
                            refresh: true,
                            pageSizes: [5, 10, 20],
                            numeric: true,
                            buttonCount: 5,
                            previousNext: true
                        };
                }
            }
            return result;
        },

        arrayRemove(arr, value) {
            return arr.filter(function (ele) {
                return ele.context.attributes["taskid"].value.toString() != value.context.attributes["taskid"].value.toString();
            });
        },

        bindEvents() {

            let vm = this;
            let gridEl = this.gridEl;
            let gridData = this.gridData;
            let self = this;
            if (this.hasCheckbox) {
                gridEl.on('change.rayBPMSGridCheckAll', '.rayBPMSGridCheckAll', function () {
                    let cbx = $(this);
                    if (cbx.prop('checked')) {
                        gridEl.find('tbody .rayBPMSGridCheckbox').prop('checked', true).trigger('change');

                    } else {
                        gridEl.find('tbody .rayBPMSGridCheckbox').prop('checked', false).trigger('change');
                    }
                });
                gridEl.on('change.rayBPMSGridCheckbox', '.rayBPMSGridCheckbox', function (e) {
                    let cbx = $(this);
                    if (!vm.isMultipleSelectable) {
                        gridEl.find('tbody .rayBPMSGridCheckbox').not(cbx).each(function () {
                            $(this).prop('checked', false);
                            $(this).closest('tr').removeClass('k-state-selected');
                        });
                    }

                    if (cbx.prop('checked')) {
                        cbx.closest('tr').addClass('k-state-selected');
                        cbx.closest('tr').attr('aria-selected', 'true');
                        cbx.attr('isSelected', 'true');

                        self.gridData.select(cbx.closest('tr'));
                        self.selectedItems.push(cbx.closest('tr'));

                    } else {
                        cbx.closest('tr').removeClass('k-state-selected');
                        cbx.closest('tr').removeAttr('aria-selected');
                        cbx.removeAttr('isSelected');
                        self.selectedItems = self.arrayRemove(self.selectedItems, cbx.closest('tr'))
                    }
                    vm.reviewAllCbxCondition();
                    vm.reviewToolbar();
                });
            }
            if (this.hasPaging && this.pagingType === "scroll") {
                let thisClass = this;

                let gridDataSource = this.gridData.dataSource;
                this.gridEl.children(".k-grid-content")
                    .on("scroll", function (e) {
                        if (thisClass.dataBindingFlag) {
                            var searchStr = $(thisClass.gridEl).find('.rayvarzBPMSGridSearch').val();
                            let dataDiv = e.target;
                            let currentPageSize = gridDataSource.pageSize();
                            payload.TaskGridRecord = 0;
                            if (dataDiv.scrollTop >= dataDiv.scrollHeight - dataDiv.offsetHeight - thisClass.scrollBarWidth
                                && gridDataSource.total() > currentPageSize) {

                                thisClass.dataBindingFlag = false;
                                if (searchStr != "") {

                                    thisClass.gridData.dataSource.query({
                                        aggregate: thisClass.gridData.dataSource.aggregate(),
                                        page: 1,
                                        pageSize: currentPageSize + thisClass.pagingIncrement,
                                        filter: thisClass.gridData.dataSource.filter(),
                                        sort: thisClass.gridData.dataSource.sort(),
                                        searchStr: searchStr
                                    });
                                }
                                else {
                                    gridDataSource.pageSize(currentPageSize + thisClass.pagingIncrement);
                                }
                            }
                        }
                    });

            }
            if (this.hasSearch) {
                this.gridEl.on('keyup.gridSearch', '.rayvarzBPMSGridSearch', (e) => {
                    let searchInput = $(e.target);
                    sessionStorage.setItem('cartableSearchItem', searchInput.val());
                    this.gridSearch(searchInput.val());
                });
            }
        },
        buildToolbar() {

            let toolbar = Array.isArray(this.toolbar) ? this.toolbar.slice() : [];
            if (this.hasSearch === "true" && (toolbar.filter((value) => {
                return value.key == 'search';
            }).length == 0)) {
                if (toolbar.length)
                    toolbar.push({
                        type: "separator"
                    });
                toolbar.push({
                    key: 'search',
                    template: "<input type='text' class='rayvarzBPMSGridSearch form-control input-sm' placeholder='" + i18n.$t("search") + "...'/>"
                });
            }
            if (toolbar.length) {
                let idIndex = 0;
                let toolbarMapFn = (value) => {
                    return {
                        id: value.type + (idIndex++),
                        type: value.type,
                        text: value.text,
                        click: this.toolbarAction(value.click),
                        icon: value.icon,
                        imageUrl: value.imageUrl,
                        enable: value.enable,
                        buttons: value.buttons ? value.buttons.map(toolbarMapFn) : undefined,
                        menuButtons: value.menuButtons ? value.menuButtons.map(toolbarMapFn) : undefined,
                        template: value.template ? value.template : undefined
                    };
                };
                this.toolbarMapped = toolbar.map(toolbarMapFn);
                this.gridToolbarData = this.gridToolbarEl.kendoToolBar({
                    items: this.toolbarMapped
                }).data('kendoToolBar');
            }
        },
        dataBound(e) {
            payload.TaskGridRecord = 0;
            this.dataBindingFlag = true
            if (this.boldOnField) {
                this.gridEl.find('tr').each((index, value) => {
                    let slf = $(value);
                    let dataItem = this.gridData.dataItem(slf);
                    if (dataItem && !dataItem[this.boldOnField]) {
                        slf.addClass('rayBPMSGridBoldRow');
                    }
                });
            }
            var self = this;

            $(self.selectedItems).each(function (index, value) {
                let el = $(value);
                let taskId = el.children('td').children('.rayBPMSGridCheckbox').attr("taskId");
                let child = $(self.gridEl).find('.rayBPMSGridCheckbox[taskId=' + taskId + ']');
                if (child.length > 0) {
                    self.reviewMultipleSelect();
                    let cbx = $(child[0]);
                    cbx.prop('checked', true);
                    cbx.closest('tr').addClass('k-state-selected');
                    cbx.closest('tr').attr('aria-selected', 'true');
                    cbx.attr('isSelected', 'true');
                    self.gridData.select(cbx.closest('tr'));
                    this.remove();
                }
            });




            // if (this.gridData.dataSource.sort() != undefined)
            //  sessionStorage.setItem('cartableSort', JSON.stringify(this.gridData.dataSource.sort()));
            var self = this;



        },
        deselectRow(tr) {

            tr = $(tr);
            tr.removeAttr('aria-selected');
            tr.removeClass('k-state-selected');
        },
        getContextMenuItems(node) {

            if (typeof this.contextMenuItems == 'function' && this.gridData) {
                let nodeData = this.gridData.dataItem(node);
                return this.contextMenuItems(node, nodeData);
            }
        },
        gridContextItemSelect(node, callback) {

            let nodeData = this.gridData.dataItem(node);
            let selectedEls = this.gridData.select();
            let selectedDatas = [];
            selectedEls.each((index, data) => {
                selectedDatas.push(this.gridData.dataItem(data));
            });

            callback(node, [nodeData], selectedDatas);
        },
        gridContextItemOpen(node, isSubMenu) {
            node = $(node);

            if (this.selectable) {
                this.reviewMultipleSelect();
                this.gridData.select(node);
                node.children('td').children('input[type="checkbox"]').each((index, value) => {
                    var cbx = $(value);
                    cbx.prop('checked', true);
                });
                var selecteds = [];
                let i = 0;
                var that = this;
                this.gridEl.find('tbody tr > td > .rayBPMSGridCheckbox').each((indexi, value) => {
                    if ($(value).prop('checked')) {
                        selecteds.push(that.gridEl.find('tbody tr')[indexi]);
                    }
                })
                var that = this;
                var selectedNodes = [];
                $(selecteds).each(function () {
                    selectedNodes.push(that.gridData.dataItem($(this)));
                });
                if (!isSubMenu)
                    this.gridContextOpen(selecteds, node, this.gridData.dataItem(node), selectedNodes);
            }
            this.reviewAllCbxCondition();
        },
        gridDetailInit(value) {

        },
        gridSearch(searchStr) {

            let filter = searchStr === "";
            if (this.dataSourceUrl === undefined) {
                filter = {
                    logic: "or",
                    filters: this.columns.map((value) => {
                        return {
                            field: value.field,
                            operator: function (item) {
                                return item !== undefined ?
                                    item.toString().toLowerCase().indexOf(searchStr) > -1 :
                                    false;
                            },
                            value: searchStr
                        };
                    })
                };
                this.gridData.dataSource.filter(filter);
            } else {
                // var s = this.gridData.dataSource.sort();
                //if (s === null || s === undefined) {
                //  s = sessionStorage.getItem('cartableSort');
                //if (s === undefined)
                //  s = null;
                //}
                this.gridData.dataSource.query({
                    aggregate: this.gridData.dataSource.aggregate(),
                    page: 1,
                    pageSize: this.gridData.dataSource.pageSize(),
                    filter: this.gridData.dataSource.filter(),
                    sort: this.gridData.dataSource.sort(),
                    searchStr: searchStr,

                });
            }
        },
        gridSelectChange(e) {
            let selectedEls = this.gridData.select();
            let thisClass = this;
            let cbxAll = this.gridEl.find('.rayBPMSGridCheckAll');
            cbxAll.prop('checked', false);
            selectedEls.each((index, value) => {
                let el = $(value);
                let cbx = el.children('td').children('.rayBPMSGridCheckbox');
                thisClass.reviewMultipleSelect();
                cbx.prop('checked', true);
            });
            this.reviewAllCbxCondition();
            this.reviewToolbar();
        },
        reviewAllCbxCondition() {

            if (this.hasCheckbox === "true" && this.isMultipleSelectable) {
                let cbxAll = this.gridEl.find('.rayBPMSGridCheckAll');
                let allCbx = this.gridEl.find('tbody tr > td > .rayBPMSGridCheckbox');
                let allCheckedCbxLenght = allCbx.filter((index, value) => {
                    return $(value).prop('checked');
                }).length;
                console.log('salam');
                if (allCbx.length === allCheckedCbxLenght)
                    cbxAll.prop('checked', true);
                else
                    cbxAll.prop('checked', false);
            }
        },
        reviewMultipleSelect() {
            let thisClass = this;
            if (!this.isMultipleSelectable) {
                this.gridEl.find('tbody tr > td > .rayBPMSGridCheckbox').prop('checked', false);
            }
        },
        reviewToolbar() {

            let enable = false;
            let forEachFn = (value) => {
                this.gridToolbarData.enable(`#${value.id}`, enable);
                if (value.buttons)
                    value.buttons.forEach(forEachFn);
                if (value.menuButtons)
                    value.menuButtons.forEach(forEachFn);
            };
            enable = !!this.gridData.select().length;
            this.toolbarMapped.forEach(forEachFn);
        },
        setColumnsVisibility() {
            var that = this;
            setTimeout(function () {
                that.hiddenColumns = JSON.parse(window.localStorage.getItem('hiddenColumns'));
                that.visibleColumns = JSON.parse(window.localStorage.getItem('visibleColumns'));
                that.customGridColumnOrder = JSON.parse(window.localStorage.getItem('CartableGridColumnOrder'));

                if (that.hiddenColumns == null)
                    that.hiddenColumns = [];
                if (that.visibleColumns == null)
                    that.visibleColumns = [];
                if (that.customGridColumnOrder == null) {
                    that.customGridColumnOrder = [];
                }
                if (that.hiddenColumns != null && that.hiddenColumns != undefined) {
                    for (var i = 0; i < that.hiddenColumns.length; i++) {
                        that.gridData.hideColumn(that.hiddenColumns[i].name);
                    }
                }
                if (that.visibleColumns != null && that.visibleColumns != undefined) {
                    for (var i = 0; i < that.visibleColumns.length; i++) {
                        that.gridData.showColumn(that.visibleColumns[i].name);
                    }
                }
                if (that.customGridColumnOrder != null && that.customGridColumnOrder != undefined) {
                    for (var i = 0; i < that.customGridColumnOrder.length; i++) {
                        that.gridData.reorderColumn(i, that.gridData.columns[that.gridData.columns.findIndex(x => x.name == that.customGridColumnOrder[i].name)]);
                    }
                }

            }, 10)
        },
        toolbarAction(callback) {
            let gridEl = this.gridEl;
            let gridData = this.gridData;
            return function (e) {
                let selectedEls = gridData.select();
                let selectedDatas = [];
                selectedEls.each((index, data) => {
                    selectedDatas.push(gridData.dataItem(data));
                });
                if (typeof callback === 'function')
                    return callback(selectedEls, selectedDatas, selectedDatas);
            }
        },
        reload() {

            this.destroy();
            this.init();
        }
    },
    updated() {

    },
    mounted() {

        this.init();
    },
    components: {
        ContextMenu
    },

}
